(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5054],{

/***/ 65054:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ components_OrchestrateJourneys_OrchestrateJourneys; }
});

// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../libs/matcha/components/ColumnTrack/index.ts + 2 modules
var ColumnTrack = __webpack_require__(85735);
// EXTERNAL MODULE: ../../libs/matcha/components/FeatureBox/index.ts
var FeatureBox = __webpack_require__(33514);
// EXTERNAL MODULE: ../../libs/matcha/recipes/CopyText/index.ts + 2 modules
var CopyText = __webpack_require__(94136);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Section/index.ts + 2 modules
var Section = __webpack_require__(88392);
// EXTERNAL MODULE: ../../libs/utils/getAbsoluteUrl/getAbsoluteUrl.ts
var getAbsoluteUrl = __webpack_require__(43848);
// EXTERNAL MODULE: ../../libs/contexts/page.ts
var page = __webpack_require__(17782);
// EXTERNAL MODULE: ../../libs/matcha/components/Image/index.ts + 2 modules
var Image = __webpack_require__(4203);
// EXTERNAL MODULE: ./src/views/TwilioEngage/components/OrchestrateJourneys/assets/OrchestrateJourneys@2x.png
var OrchestrateJourneys_2x = __webpack_require__(58338);
var OrchestrateJourneys_2x_default = /*#__PURE__*/__webpack_require__.n(OrchestrateJourneys_2x);
// EXTERNAL MODULE: ./src/views/TwilioEngage/components/OrchestrateJourneys/assets/OrchestrateJourneys.webp
var OrchestrateJourneys = __webpack_require__(12349);
var OrchestrateJourneys_default = /*#__PURE__*/__webpack_require__.n(OrchestrateJourneys);
// EXTERNAL MODULE: ./src/views/TwilioEngage/components/OrchestrateJourneys/assets/OrchestrateJourneys@2x.webp
var assets_OrchestrateJourneys_2x = __webpack_require__(92460);
var assets_OrchestrateJourneys_2x_default = /*#__PURE__*/__webpack_require__.n(assets_OrchestrateJourneys_2x);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ./src/views/TwilioEngage/components/OrchestrateJourneys/OrchestrateJourneysImage.tsx







var SIZES = "540px, 1080px";

var OrchestrateJourneysImage = function OrchestrateJourneysImage() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ImageWrapper, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("picture", {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
        type: "image/webp",
        srcSet: "".concat((OrchestrateJourneys_default()), " 540w, ").concat((assets_OrchestrateJourneys_2x_default()), " 1080w"),
        sizes: SIZES
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* default */.Z, {
        src: (OrchestrateJourneys_2x_default()),
        sizes: SIZES,
        alt: "Orchestrate Journeys",
        width: "618",
        height: "661",
        loading: "lazy"
      })]
    })
  });
};

var ImageWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e4mqs200"
} : 0)("display:flex;flex-direction:column;justify-content:center;align-items:center;padding:0px;", function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.up("lg");
}, "{height:100%;}" + ( true ? "" : 0));

/* harmony default export */ var OrchestrateJourneys_OrchestrateJourneysImage = (OrchestrateJourneysImage);
;// CONCATENATED MODULE: ./src/views/TwilioEngage/components/OrchestrateJourneys/OrchestrateJourneys.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }










var copy = {
  heading: "Orchestrate journeys where the data is",
  description: "Design personalized multichannel journeys using our drag-and-drop visual builder to automate messaging across paid and owned channels."
};
var OrchestrateJourneys_link = {
  text: "Explore Journeys",
  url: "/product/twilio-engage/journeys/"
};
var features = [{
  heading: "Go from idea to campaign in minutes",
  description: "Save time to execution by streamlining personalized journey creation and experimenting on new channels quickly."
}, {
  heading: "Analyze your multichannel journeys in one place",
  description: "Track the performance of your multichannel campaigns, gain a high level view with Journey Analytics and set custom conversion goals to understand ROI performance\u2014allowing you to truly understand your customer journey."
}, {
  heading: "Centrally manage omnichannel customer engagement campaigns at scale",
  description: "Orchestrate and scale personalized campaigns everywhere your customers are using our <a href=\"https://segment.com/catalog/\">".concat("450", "+ out-of-the-box integrations</a>.")
}];

var OrchestrateJourneys_OrchestrateJourneys = function OrchestrateJourneys() {
  var pageConfig = (0,page/* usePageConfig */.Gm)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(SectionWrapper, {
    variant: "2Col",
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledSectionCopy, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
          tag: "h2",
          children: copy.heading
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
          children: copy.description
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ColumnTrackWrapper, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ColumnTrack/* default */.Z, {
          gap: "small",
          children: features.map(function (feature, index) {
            return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeatureBox/* default */.ZP, {
              alignment: "left",
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(FeatureBox/* Body */.uT, {
                children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeatureBox/* Title */.Dx, {
                  children: feature.heading
                }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeatureBox/* Text */.xv, {
                  dangerouslySetInnerHTML: {
                    __html: feature.description
                  }
                })]
              })
            }, index);
          })
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Link */.rU, {
        href: (0,getAbsoluteUrl/* default */.Z)(OrchestrateJourneys_link.url, pageConfig),
        children: OrchestrateJourneys_link.text
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OrchestrateJourneys_OrchestrateJourneysImage, {})
    })]
  });
};

var SectionWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "e1d51iwo2"
} : 0)( true ? {
  name: "ajfln6",
  styles: "overflow-x:visible"
} : 0);

var StyledSectionCopy = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* Copy */.CK,  true ? {
  target: "e1d51iwo1"
} : 0)("direction:ltr;", function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.up("lg");
}, "{justify-self:end;max-width:440px;}" + ( true ? "" : 0));

var ColumnTrackWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1d51iwo0"
} : 0)( true ? {
  name: "1lw3ul3",
  styles: "margin-top:40px"
} : 0);

/* harmony default export */ var components_OrchestrateJourneys_OrchestrateJourneys = (OrchestrateJourneys_OrchestrateJourneys);
;// CONCATENATED MODULE: ./src/views/TwilioEngage/components/OrchestrateJourneys/index.ts


/***/ }),

/***/ 33514:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dx": function() { return /* reexport safe */ _FeatureBox__WEBPACK_IMPORTED_MODULE_0__.Dx; },
/* harmony export */   "Hq": function() { return /* reexport safe */ _FeatureBox__WEBPACK_IMPORTED_MODULE_0__.Hq; },
/* harmony export */   "ZP": function() { return /* reexport safe */ _FeatureBox__WEBPACK_IMPORTED_MODULE_0__.Ob; },
/* harmony export */   "h4": function() { return /* reexport safe */ _FeatureBox__WEBPACK_IMPORTED_MODULE_0__.h4; },
/* harmony export */   "uT": function() { return /* reexport safe */ _FeatureBox__WEBPACK_IMPORTED_MODULE_0__.uT; },
/* harmony export */   "xv": function() { return /* reexport safe */ _FeatureBox__WEBPACK_IMPORTED_MODULE_0__.xv; }
/* harmony export */ });
/* harmony import */ var _FeatureBox__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13379);

_FeatureBox__WEBPACK_IMPORTED_MODULE_0__/* .FeatureBox.displayName */ .Ob.displayName = "FeatureBoxBase";
_FeatureBox__WEBPACK_IMPORTED_MODULE_0__/* .Body.displayName */ .uT.displayName = "FeatureBox.Body";
_FeatureBox__WEBPACK_IMPORTED_MODULE_0__/* .Header.displayName */ .h4.displayName = "FeatureBox.Header";
_FeatureBox__WEBPACK_IMPORTED_MODULE_0__/* .Text.displayName */ .xv.displayName = "FeatureBox.Text";
_FeatureBox__WEBPACK_IMPORTED_MODULE_0__/* .Title.displayName */ .Dx.displayName = "FeatureBox.Title";


/***/ }),

/***/ 58338:
/***/ (function(module) {

module.exports = "/_next/static/images/OrchestrateJourneys@2x-a91501c2db15f398cceb6cfc17798b97.png";

/***/ }),

/***/ 12349:
/***/ (function(module) {

module.exports = "/_next/static/images/OrchestrateJourneys-a0eb8431ef6a619095a43c2a2f8091e3.webp";

/***/ }),

/***/ 92460:
/***/ (function(module) {

module.exports = "/_next/static/images/OrchestrateJourneys@2x-2c9ca120bf28849604e5c9b5ee6a0543.webp";

/***/ })

}]);